import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { IMG } from "@/lib/images";

export default function CTASection({
    title = "Ready to accelerate your survey drafting pipeline?",
    subtitle = "Upload field data today. Get a stamped CAD deliverable tomorrow.",
    primaryLabel = "Get Started",
    primaryTo = "/get-started",
}) {
    return (
        <section className="relative overflow-hidden rounded-3xl border border-slate-800" data-testid="cta-section">
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `url(${IMG.droneSite})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    opacity: 0.28,
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-br from-[#030712]/90 via-[#030712]/80 to-[#0b1120]/80" />
            <div className="relative p-10 md:p-16 grid grid-cols-1 md:grid-cols-5 gap-8 items-center">
                <div className="md:col-span-3">
                    <div className="overline mb-4">Step into your next project</div>
                    <h2 className="font-heading text-3xl md:text-5xl font-bold text-slate-50 leading-[1.05] tracking-tight">
                        {title}
                    </h2>
                    <p className="text-slate-300 mt-5 max-w-xl leading-relaxed">{subtitle}</p>
                </div>
                <div className="md:col-span-2 flex flex-wrap md:justify-end gap-3">
                    <Link to={primaryTo} className="btn-primary" data-testid="cta-primary-btn">
                        {primaryLabel} <ArrowRight size={16} weight="bold" />
                    </Link>
                    <Link to="/contact" className="btn-ghost" data-testid="cta-contact-btn">
                        Talk to an expert
                    </Link>
                </div>
            </div>
        </section>
    );
}
